/* eslint-disable react/no-danger */
import React, {useState, useEffect }from 'react';
import PropTypes from 'prop-types';
import styles from './StandAloneButtons.scss';

const StandAloneButtons = (props) => {
  const { widgetConfig } = props;
  const [
    canShowTradeInStandAlone,
    setCanShowTradeInStandAlone,
  ] = useState(false);
  const [canShowPreApprovalStandAlone, setCanShowPreApprovalStandAlone] = useState(false);
  const [canShowBrowseStandAlone, setCanShowBrowseStandAlone] = useState(false);

  useEffect(() => {
    setCanShowTradeInStandAlone(widgetConfig?.STANDALONE?.tradeInButton?.enabled);
    setCanShowPreApprovalStandAlone(widgetConfig?.STANDALONE?.preApprovalButton?.enabled);
    setCanShowBrowseStandAlone(widgetConfig?.STANDALONE?.browseButton?.enabled);
  }, [widgetConfig]);

  return (
    <div className={styles.standAloneButtonsContainer}>
      {canShowTradeInStandAlone && (
        <div className={styles.standAloneButtonContainer}>
          <div className='prodigy-standalone-tradein-button'></div>
        </div>
      )}
      {canShowPreApprovalStandAlone && (
        <div className={styles.standAloneButtonContainer}>
          <div className='prodigy-standalone-preapproval-button'></div>
        </div>
      )}
      {canShowBrowseStandAlone && (
        <div className={styles.standAloneButtonContainer}>
          <div className='prodigy-standalone-browse-button'></div>
        </div>
      )}
    </div>
  );
};

StandAloneButtons.propTypes = {
  widgetConfig: PropTypes.object,
};

export default StandAloneButtons;



// WEBPACK FOOTER //
// ./src/components/StandAloneButtons/StandAloneButtons.js